import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GiveBoxEvent } from '@bonusly/common-give-box';
import { Button, Image, rem, Text, VStack } from '@bonusly/design-system';
import { useDispatch } from '@bonusly/events';

import leaderboardEmptyImage from './leaderboard-empty.png';

export const LeaderboardEmptyState: FC = () => {
	const { t } = useTranslation('navigation');
	const dispatch = useDispatch();

	const handleGiveRecognition = () => {
		dispatch(GiveBoxEvent.Open);
	};

	return (
		<VStack spacing={rem(16)} alignItems="center" justifyContent="center" py={rem(80)} w="100%">
			<Image src={leaderboardEmptyImage} alt="" w={rem(166)} h={rem(142)} objectFit="contain" />

			<VStack spacing={rem(8)} maxW={rem(270)} textAlign="center">
				<Text fontSize="md" fontWeight="semibold" color="text.default" lineHeight="20px">
					{t('leaderboard.emptyState.title')}
				</Text>
				<Text fontSize="sm" color="text.softest" lineHeight="20px">
					{t('leaderboard.emptyState.description')}
				</Text>
			</VStack>

			<Button colorScheme="secondary" size="md" onClick={handleGiveRecognition} borderRadius={rem(12)}>
				{t('leaderboard.emptyState.giveRecognition')}
			</Button>
		</VStack>
	);
};
